module.exports = __webpack_public_path__ + "img/2.234ac35e.png";